import React from "react";
import Hotspots from "../hotspots/Hotspots";

const ModelViewerElement = React.forwardRef((props, ref) => (
  <model-viewer
    ref={ref}
    class={props.style.modelViewer}
    id="model"
    camera-orbit="0deg 90deg 0deg"
    shadow-intensity="1"
    camera-controls
    environment-image={props.environmentImage}
    interaction-prompt="none"
    src={props.src}
    style={{ background: props.background }}
    skybox-image={props.useSkybox ? props.environmentImage : ""}
  >
    <Hotspots />
  </model-viewer>
));

export default ModelViewerElement;
